<div class="popup" [formGroup]="commentForm">
    <div class="popup-header">
        <div class="header-left">
            <div class="edit-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 20.0002H21M16.5 3.50023C16.8978 3.1024 17.4374 2.87891 18 2.87891C18.2786 2.87891 18.5544 2.93378 18.8118 3.04038C19.0692 3.14699 19.303 3.30324 19.5 3.50023C19.697 3.69721 19.8532 3.93106 19.9598 4.18843C20.0665 4.4458 20.1213 4.72165 20.1213 5.00023C20.1213 5.2788 20.0665 5.55465 19.9598 5.81202C19.8532 6.06939 19.697 6.30324 19.5 6.50023L7 19.0002L3 20.0002L4 16.0002L16.5 3.50023Z" stroke="#6449DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
            </div>
        <h2 class="header-title">{{ 'companies.addOrEditComment' | translate }}</h2>
        </div>
        <div class="close-icon" (click)="close()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="#232529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
        </div>
    </div>

    <div class="input-group">
        <label class="input-label">{{ 'companies.openCommentField' | translate }}</label>
        <div class="input-field">
            <textarea class="comment-textarea" placeholder="{{ 'companies.commentOnOrderDocuments' | translate }}" formControlName="comment"></textarea>
        </div>
    </div>


    <div class="button-group">
        <button class="btn btn-cancel" (click)="close()">
            {{ 'common.cancel' | translate }}
        </button>
        <button class="btn btn-update" (click)="save()">
            {{ 'companies.update' | translate }}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
        </button>
    </div>
</div>